import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['amountInput', 'descriptionInput', 'select']

  connect() {
    if (this.hasSelectTarget) {
      this.selectTarget.dispatchEvent(new Event('change'))
    }
  }

  update() {
    const selectedIndex = event.currentTarget.selectedIndex
    const selectedOption = event.currentTarget.options[selectedIndex]

    this.amountInputTarget.value = selectedOption.dataset.amount
    this.descriptionInputTarget.value = selectedOption.dataset.description
  }
}
